import React, { useEffect, useState, useContext } from "react";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { getComments } from "../../../services/tribe";
import Loading from "../../atoms/loading/loading";
import CardComment from "../../atoms/card-comment/cardComment";
import Button from "../../atoms/button/button";
import GlobalContext from "../../../contexts/globalContext";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import CommentDetailModal from "../comment-detail-modal/commentDetailModal";
import MobileCommentModal from "../../molecules/mobile-comment-modal/mobileCommentModal";
import ModalApprove from "../../atoms/modal-approve/modalApprove";

import "./commentsSection.scss";

const CommentsSection = (props: ReferenciaContenido) => {
  const [isReady, setIsReady] = useState(false);
  const [totalComments, setTotalComments] = useState<Array<any>>([]);
  const [seeMoreStep, setSeeMoreStep] = useState(1);
  const [comments, setComments] = useState<Array<any>>([]);
  const [userId, setUserId] = useState("");
  const [userInfo, setUserInfo] = useState<any>({});
  const [userUid, setUserUid] = useState<any>(undefined);
  const [commentsPerPage, setCommentsPerPage] = useState(12);
  const [commentsPerRow, setCommentsPerRow] = useState(3);
  const [idxSelection, setIdxSelection] = useState<any>(undefined);
  const [showNewCommentModal, setShowNewCommentModal] = useState(false);
  const [showCommentMsgModal, setShowCommentMsgModal] = useState(false);
  const [editingComment, setEditingComment] = useState<any>(undefined);
  const [editingId, setEditingId] = useState<any>("");
  const [replyCommentId, setReplyCommentId] = useState<any>(undefined);
  const { gigyaContext: { gigyaAccount }, gigyaUid } = useContext(GlobalContext);
  const { window } = useBrowserMode();

  useEffect(() => {
    const getCommentsFn = async () => {
      setIsReady(false);
      setUserId("");
      setUserInfo(gigyaAccount?.profile || {});
      if (props.autoresArticulo[0]) {
        let comPR = 3;
        let comPP = 12;
        if (window.innerWidth < 452) {
          comPR = 1;
          comPP = 5;
        } else if (window.innerWidth < 801) {
          comPR = 2;
          comPP = 8;
        } else if (window.innerWidth < 1366) {
          comPR = 3;
          comPP = 9;
        } else {
          comPR = 3;
          comPP = 12;
        }
        setCommentsPerRow(comPR);
        setCommentsPerPage(comPP);
        const conversationId = props.autoresArticulo[0];
        const response: any = await getComments(
          conversationId,
          gigyaAccount?.profile && gigyaAccount?.profile.email,
          gigyaAccount?.profile.firstName +
            " " +
            gigyaAccount?.profile.lastName || "",
          gigyaAccount?.UID || ""
        );
        setIsReady(true);
        setUserId(response.userId || "");
        setTotalComments([]);
        setComments([]);
        setTotalComments(response.comments);
        setComments(
          response.comments.length
            ? orderComments(comPR, response.comments.slice(0, comPP))
            : []
        );
        setUserUid(gigyaAccount?.UID || null);
      } else {
        setTotalComments([]);
        setComments([]);
        setIsReady(true);
      }
    };
    getCommentsFn();
  }, [gigyaAccount?.UID]);

  useEffect(() => {
    if (gigyaUid?.get !== userUid && userUid !== undefined) {
      location.reload();
    }
  }, [gigyaUid?.get]);

  const orderComments = (columns: number, initialArray: Array<any>) => {
    let orderedComments: Array<any> = [];
    for (let i = 0; i < initialArray.length; i++) {
      if (i < columns) {
        orderedComments[i] = [initialArray[i]];
      } else {
        const indexToPush = i % columns;
        orderedComments[indexToPush].push(initialArray[i]);
      }
    }
    return orderedComments;
  };

  const seeMore = () => {
    setSeeMoreStep(seeMoreStep + 1);
    const commentsLimit = (seeMoreStep + 1) * commentsPerPage;
    setComments(
      orderComments(commentsPerRow, totalComments.slice(0, commentsLimit))
    );
  };

  const handleSelection = (commentId: string) => {
    const commentIndex = totalComments.findIndex((com) => com.id === commentId);
    setIdxSelection(commentIndex);
  };

  const handleEditingComment = (orginalComment, commentId) => {
    setEditingComment(orginalComment);
    setEditingId(commentId);
  };

  return (
    <section className="o-comments-section">
      {isReady ? (
        comments.length > 0 ? (
          <>
            <div className="o-comments-section__comments">
              {comments.map((commentColumn, idx) => (
                <div key={idx} className="o-comments-section__comments-column">
                  {commentColumn.map((comment, index) => {
                    return (
                      <CardComment
                        key={index}
                        {...comment}
                        userId={userId}
                        userInfo={userInfo}
                        handleSelection={handleSelection}
                        showComments={true}
                        showInput={true}
                        handleNewCommentModal={setShowNewCommentModal}
                        gigyaAccount={gigyaAccount}
                        editingCommentHandler={handleEditingComment}
                        setReplyCommentId={setReplyCommentId}
                      />
                    );
                  })}
                </div>
              ))}
            </div>
            {totalComments.length / commentsPerPage - seeMoreStep > 0 && (
              <div className="o-comments-section__see-more">
                <Button
                  type="button"
                  classname="primary "
                  isDisabled={false}
                  text={props.tituloBoton}
                  onClickAction={seeMore}
                />
              </div>
            )}
          </>
        ) : (
          <div className="o-comments-section__empty">
            <i className="o-comments-section_empty_icon icon-comments1"></i>
            <div className="o-comments-section_empty_text">
              {props.descripcion.json.content[0].content[0].value}
            </div>
          </div>
        )
      ) : (
        <Loading />
      )}
      <CommentDetailModal
        title={props.etiquetasArticulo[0] || ""}
        setCommentIdx={setIdxSelection}
        totalComments={totalComments}
        commentIdx={idxSelection}
        userId={userId}
        userInfo={userInfo}
        gigyaAccount={gigyaAccount}
        showNewCommentModal={setShowNewCommentModal}
        setReplyCommentId={setReplyCommentId}
      />
      {showNewCommentModal && (
        <MobileCommentModal
          closeModal={() => {
            setShowNewCommentModal(false);
            setEditingComment(undefined);
          }}
          closeModalPublish={() => {
            setShowNewCommentModal(false);
            setShowCommentMsgModal(true);
            setEditingComment(undefined);
            setReplyCommentId(false);
          }}
          valueInput={editingComment != undefined ? editingComment : undefined}
          updatingComment={editingId ? editingId : ""}
          idConversation={props.autoresArticulo[0]}
          urlImage={null}
          replyingCommentId={replyCommentId}
        />
      )}
      <ModalApprove
        onClose={() => {
          setShowCommentMsgModal(false);
          window.location.reload();
        }}
        open={showCommentMsgModal}
      />
    </section>
  );
};

export default CommentsSection;
